module.exports = __webpack_public_path__ + "static/media/select-circular.634f90b9.svg";